import { render, staticRenderFns } from "./CredenciamentoAtualizacaoSelecaoParticipantes.vue?vue&type=template&id=253bdb0b"
import script from "./CredenciamentoAtualizacaoSelecaoParticipantes.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAtualizacaoSelecaoParticipantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports